"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _widgetHelpers = require("./util/widgetHelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  className: _propTypes.default.string,
  role: _propTypes.default.string,
  nodeRef: _propTypes.default.func,
  emptyListMessage: _propTypes.default.node
};

var Listbox = _react.default.forwardRef(function (_ref, ref) {
  var _extends2;

  var className = _ref.className,
      role = _ref.role,
      children = _ref.children,
      emptyListMessage = _ref.emptyListMessage,
      nodeRef = _ref.nodeRef,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "role", "children", "emptyListMessage", "nodeRef"]);

  var id = (0, _widgetHelpers.useInstanceId)();
  return _react.default.createElement("div", _extends((_extends2 = {
    id: id,
    ref: ref,
    tabIndex: "-1"
  }, _extends2["ref"] = nodeRef, _extends2.className = (0, _classnames.default)(className, 'rw-list'), _extends2.role = role === undefined ? 'listbox' : role, _extends2), props), _react.default.Children.count(children) ? children : _react.default.createElement("div", {
    className: "rw-list-empty"
  }, emptyListMessage));
});

Listbox.displayName = Listbox;
Listbox.propTypes = propTypes;
var _default = Listbox;
exports.default = _default;
module.exports = exports["default"];